import { DATE_FORMATS } from "@bps/date-time";
import { nameof } from "@libs/utils/name-of.utils.ts";
import {
  isNotFutureDate,
  required,
  validDate
} from "@libs/validation/fieldValidators.ts";
import { Validator } from "@libs/validation/Validator.ts";
import { PatientDeclarationFormValues } from "@shared-types/acc/patient-declaration-values.type.ts";

export class PatientDeclarationFormValidator extends Validator<PatientDeclarationFormValues> {
  constructor() {
    super();
    this.forField(nameof("patientDeclared"), [required()]);
    this.forField(nameof("patientClaimAuthorised"), [required()]);
    this.forField(nameof("patientInfoAuthorised"), [required()]);
    this.forField(nameof("patientAccContactAuthorised"), [required()]);
    this.forField(nameof("patientDeclaration"), [
      validDate(DATE_FORMATS.DAY_DEFAULT_FORMAT),
      isNotFutureDate(),
      required()
    ]);
  }
}
